<template>
  <div>
      <el-form :model="followupForm" label-width="80px">
            <el-form-item label="跟进时间">
                <el-date-picker
                    v-model="followupForm.time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                    :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="跟进方式">
                <el-select
                        v-model="followupForm.way"
                        placeholder="请选择"
                        style="width: 100%;position: relative"
                        :class="followupForm.way!=='其他'?'activeClass':''"
                >
                    <el-option
                    v-for="item in followupForm.ways"
                    size="medium"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>

                </el-select>
            </el-form-item>
          <el-form-item label="跟进状态">
              <el-select
                      v-model="followupForm.statusId"
                      placeholder="请选择"
                      style="width: 100%;position: relative"
              >
                  <el-option
                          v-for="item in statusList"
                          size="medium"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                  </el-option>

              </el-select>
          </el-form-item>
            <el-form-item label="内容描述" >
            <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="followupForm.description"
                maxlength="300"
                show-word-limit
                :autosize="{ minRows:4,maxRows:6}"
                >
                </el-input>
            </el-form-item>
        </el-form>
  </div>
</template>

<script>
export default {
    data(){
        return{
            followupForm: {
                time: [new Date(),new Date()],
                way: '',
                statusId:'',
                ways: [
                    {
                        value:'MOBILE',
                        label:'电话'
                    },
                    {
                        value:'ONSITEVISIT',
                        label:'现场拜访'
                    },
                    {
                        value:'MESSAGE',
                        label:'短信'
                    },
                    {
                        value:'INTERVIEW',
                        label:'面谈'
                    },
                    {
                        value:'WECHAT',
                        label:'微信'
                    },
                    {
                      value:'ENTERPRISEWECHAT',
                      label:'企业微信'
                    },
                    {
                      value:'DINGDING',
                      label:'钉钉'
                    },
                    {
                      value:'TELECONFERENCE',
                      label:'远程会议'
                    },
                    {
                        value:'OTHER',
                        label:'其他'
                    }
                ],
                description: '',
            },
            statusList:[],
            elOption:'',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > new Date(new Date().toLocaleDateString()).getTime()+24 * 60 * 60 * 1000 - 1;//如果没有后面的-8.64e6就是不可以选择今天的
                }
            },
        }
    },
    methods:{
        addWays(){
            let value={
                value:this.elOption,
                label:this.elOption,
            }
            this.followupForm.ways.push(value)
            this.elOption=''
        },
        checkOther(){
            this.followupForm.way='其他'
        }
    }
}
</script>

<style lang="less" scoped>
.otherWays{
    ont-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    cursor: pointer;
    margin-bottom: 36px;
}
.activeClass{
    background-color:#f5f7fa ;
}
.otherWays:hover{
    background-color:#f5f7fa ;
}
</style>